import React, { useState, useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { useAppContext } from '../AppContext';
import { useTranslation } from 'react-i18next';

function InviteModal({ nexusId, onClose }) {
    const { appFunctions, setMessage } = useAppContext();
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('connected');
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchUsers = async () => {
            setIsLoading(true);
            const getUsersToInvite = httpsCallable(appFunctions, 'getUsersToInvite');
            try {
                const result = await getUsersToInvite({ nexusId, filter: activeTab });
                setUsers(result.data.users);
            } catch (error) {
                setMessage(t('inviteModal.fetchError', { message: error.message }));
            }
            setIsLoading(false);
        };

        fetchUsers();
    }, [activeTab, appFunctions, nexusId, setMessage, t]);

    const handleInvite = async (userId) => {
        const inviteFn = httpsCallable(appFunctions, 'inviteUserToNexus');
        try {
            const result = await inviteFn({ nexusId, userId });
            setMessage(result.data.message);
        } catch (error) {
            setMessage(t('inviteModal.inviteError', { message: error.message }));
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-gray-800 rounded-lg shadow-lg p-6 w-full max-w-md">
                <h2 className="text-2xl font-bold mb-4">{t('inviteModal.title')}</h2>
                <div className="flex border-b border-gray-700 mb-4">
                    <button onClick={() => setActiveTab('connected')} className={`px-4 py-2 ${activeTab === 'connected' ? 'border-b-2 border-purple-500' : ''}`}>{t('inviteModal.tabs.connected')}</button>
                    <button onClick={() => setActiveTab('online')} className={`px-4 py-2 ${activeTab === 'online' ? 'border-b-2 border-purple-500' : ''}`}>{t('inviteModal.tabs.online')}</button>
                    <button onClick={() => setActiveTab('all')} className={`px-4 py-2 ${activeTab === 'all' ? 'border-b-2 border-purple-500' : ''}`}>{t('inviteModal.tabs.all')}</button>
                </div>
                {isLoading ? (
                    <p>{t('inviteModal.loading')}</p>
                ) : (
                    <ul className="space-y-2">
                        {users.map(user => (
                            <li key={user.id} className="flex items-center justify-between">
                                <span>{user.displayName}</span>
                                <button onClick={() => handleInvite(user.id)} className="small-action-button bg-blue-600 hover:bg-blue-500">{t('inviteModal.inviteButton')}</button>
                            </li>
                        ))}
                    </ul>
                )}
                <button onClick={onClose} className="mt-4 small-action-button bg-gray-600 hover:bg-gray-500">{t('inviteModal.closeButton')}</button>
            </div>
        </div>
    );
}

export default InviteModal;
